<template>
  <div>
    <div class="input_box">
      <input
        :autofocus="autofocus"
        :type="type"
        ref="ipt"
        v-model="inputValue"
        :max='max'
        :maxlength="maxlength"
        :minlength="minlength"
        class="base_input"
        :placeholder="placeholder"
        :class="[is_focus? 'focus' : '', errMsg?'has-errror':'']"
        v-bind="$attrs"
        @focus="onFocus"
        @blur="onBlur"
        @input="triggerInput"
      />
      <div class="span_title" :class="is_focus? 'title_focus': ''">{{ title }}</div>
    </div>
    <span class='error' v-show='errMsg'>{{errMsg}}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_focus: false,
      input_length: 0
    };
  },

  props: {
    value: {},
    type: {
      // input 类型
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: "请输入关键字"
    },
    minlength: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    title: {
      // input框标题
      type: String,
      default: "手机号"
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    errMsg: {
      type: String,
      default: ''
    }
  },

  computed: {
    inputValue: {
      get() {
       return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    triggerInput() {
      this.$emit('inputTest')

    },

    onFocus() {
      this.is_focus = true;
      this.$emit('focus')
    },

    onBlur() {
      this.is_focus = false;
      this.$emit('blur')
    },

    focus() {
      this.is_focus = true;
    },
    // 调用 手动控制输入框聚焦
    onFocusHandle() {
      this.$refs.ipt.focus()
    }
  }
};
</script>

<style lang='scss' scoped>
.input_box {
  position: relative;

  .base_input {
    width: 100%;
    height: 50px;
    // line-height: 50px;
    outline-style: none;
    font-size: 14px;
    color: #333;
    padding: 15px 10px 15px 60px;
    background: #ffffff;
    text-align: right;
    border: 2px solid rgba(239, 242, 244, 1);
    border-radius: 5px;
  }
  .pd102 {
    padding-right: 102px;
  }
  .focus {
    font-size: 14px;
    border: 2px solid #009688;
  }

  .has-errror {
    border: 2px solid #EE5B5B;
  }

  .span_title {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    font-size: 14px;
    color: #666;
  }

  .title_focus {
    color: #009688;
    font-weight: 600;
  }



  // .is_button {
  //   right: 0;
  //   position: absolute;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   height: 34px;
  //   line-height: 34px;
  //   text-align: center;
  //   font-size: 14px;
  //   font-weight: 600;
  //   width: 90px;
  //   border-left: 2px solid #eef2f4;

  //   .is_one {
  //     color: rgba(0,150,136,0.30);
  //   }

  //   .is_two {
  //     color: #009688;
  //   }
  // }
}
.error {
  display: inline-block;
  color: #EE5B5B;
  font-size: 12px;
  font-weight: bolder;
  padding-left: 5px;
  margin-top: 10px;
}
</style>